// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import qs from 'qs'
import 'element-ui/lib/theme-chalk/index.css'
import Global from '../static/config/global'
import store from './store/store.js'
import VueClipboard from 'vue-clipboard2'
import VueQriously from 'vue-qriously'
import promise from 'es6-promise'
import MetaInfo from 'vue-meta-info'

promise.polyfill()

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(VueQriously)
Vue.use(MetaInfo)

axios.defaults.withCredentials = true
const axiosInstance = axios.create({
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}, // 设置传输内容的类型和编码
  withCredentials: true, // 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
  baseURL: process.env.API_ROOT
})

Vue.prototype.$axios = axiosInstance
Vue.prototype.$qs = qs
Vue.prototype.GLOBAL = Global

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: store,
  router,
  components: { App },
  template: '<App/>'
})

axiosInstance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回401，清除cookie信息并跳转到登录页
          // 设置登录状态为false
          store.dispatch('setLogin', 'false')
          if (router.currentRoute.name !== 'login') {
            router.replace({
              path: 'login',
              query: {redirect: router.currentRoute.fullPath}
            })
          }
      }
    }
    // 返回错误信息
    return Promise.reject(error.response.data)
  }
)



// WEBPACK FOOTER //
// ./src/main.js